import React from 'react';
import './StoreOptions.css';
import {
  FaArrowRight,
  FaClock,
} from "react-icons/fa";
import {
  FiHome,
  FiPackage,
  FiShoppingCart,
  FiCreditCard,
  FiMessageCircle,
  FiSmartphone,
  FiShield,
} from "react-icons/fi";

const StoreOptions = () => {

  const handleDemoClick = () => {
    window.open('https://demo-site.creativepulse.pk/', '_blank', 'noopener,noreferrer');
  };

  const features = [
    {
      back: "#7C3AED",
      icon: <FiHome />,
      title: "Branded Online Store",
      description: "Your own .com presence",
      gradient: "linear-gradient(135deg, #ede9fe, #f5f3ff)"
    },
    {
      back: "#F97316",
      icon: <FiPackage />,
      title: "Product Pages",
      description: "Variants, images, badges",
      gradient: "linear-gradient(135deg, #ffe4d6, #fff4ec)"
    },
    {
      back: "#22C55E",
      icon: <FiShoppingCart />,
      title: "Cart & Checkout",
      description: "Smooth order flow",
      gradient: "linear-gradient(135deg, #dcfce7, #f0fdf4)"
    },
    {
      back: "#EAB308",
      icon: <FiCreditCard />,
      title: "COD + Online Payments",
      description: "Both options ready",
      gradient: "linear-gradient(135deg, #fef3c7, #fffbeb)"
    },
    {
      back: "#22C55E",
      icon: <FiMessageCircle />,
      title: "WhatsApp Support",
      description: "Customers can ping you",
      gradient: "linear-gradient(135deg, #dcfce7, #f0fdf4)"
    },
    {
      back: "#7C3AED",
      icon: <FiSmartphone />,
      title: "Mobile-First",
      description: "Designed for phones",
      gradient: "linear-gradient(135deg, #ede9fe, #f5f3ff)"
    },
    {
      back: "#111827",
      icon: <FiShield />,
      title: "Policy Pages",
      description: "All essentials included",
      gradient: "linear-gradient(135deg, #ffe4d6, #fff4ec)"
    },
    {
      back: "#F97316",
      icon: <FaClock />,
      title: "Ready in 3 Days",
      description: "Launch this week",
      gradient: "linear-gradient(135deg, #dbeafe, #eff6ff)"
    }
  ];

  return (
    <section className="store-options-section">
      <div className="store-options-container">
        {/* Renamed from "features-grid" — that class name was also defined
            in Pages.css for a totally different section, causing a global
            CSS collision. This name is now unique to this component. */}
        <div className="store-options-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card" style={{ background: feature.gradient }}>
              <div className='icon-background' style={{ background: feature.back }}>
                <div className="feature-icon-StoreOptions">{feature.icon}</div>
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="cta-row">
          <div className='cta-pill-dark'>
            <FaClock className="cta-pill-icon" />
            <span>Store ready in 3 working days</span>
          </div>
          <button className="cta-button" onClick={handleDemoClick}>
            View Demo Store
            <FaArrowRight />
          </button>
        </div>
      </div>
    </section>
  );
};

export default StoreOptions;